import firebase from 'firebase';
import UserInfo from './userInfo';
import utils from './utils';

const provider = new firebase.auth.TwitterAuthProvider();

const findSetSignedInAndCall = (appCtrlr, additionalUserInfo, user) => {
  if (appCtrlr.setSignedIn !== undefined) {
    if (appCtrlr) {
      appCtrlr.setSignedIn({
        newUser: additionalUserInfo.isNewUser,
        authRes: user,
      });
    }
    if (!appCtrlr) utils.log('App not found');
  } else {
    appCtrlr.$children.map((item) => findSetSignedInAndCall(item, additionalUserInfo, user));
  }
};

const findSetSignedOutAndCall = (appCtrlr) => {
  if (appCtrlr.setSignedIn !== undefined) {
    if (appCtrlr) appCtrlr.setSignedOut();
    if (!appCtrlr) utils.log('App not found');
  } else {
    appCtrlr.$children.map((item) => findSetSignedOutAndCall(item));
  }
};

export default {
  loginWithTwitter() {
    firebase.auth().signInWithRedirect(provider);
  },

  getLoginResult(cmp) {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .getRedirectResult()
        .then(async (result) => {
          if (result.user) {
            const { credential, user, additionalUserInfo } = result;
            // const { secret } = credential;
            const token = credential.accessToken;
            utils.log('Signed In');
            const customToken = await UserInfo.mintToken(user.uid).token;
            utils.log(`Here's your custom token${customToken}`);
            const appCtrlr = utils.app(cmp);
            findSetSignedInAndCall(appCtrlr, additionalUserInfo, user);
            resolve({
              userId: user.uid,
              userName: user.displayName,
              acctUsername: additionalUserInfo.username,
              userEmail: user.email,
              token,
              isNewUser: additionalUserInfo.isNewUser,
              profilePic: user.photoURL,
              emailVerified: user.emailVerified,
            });
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCurrentUser() {
    return firebase.auth().currentUser;
  },

  getAuthToken() {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then((idToken) => {
          resolve(idToken);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  watchAuthStateChange() {
    return new Promise((resolve) => {
      firebase.auth().onAuthStateChanged((user) => {
        resolve(user);
      });
    });
  },

  logout(cmp) {
    firebase
      .auth()
      .signOut()
      .then(() => {
        const appCtrlr = utils.app(cmp);
        findSetSignedOutAndCall(appCtrlr);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
